import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "transaction-message" }
const _hoisted_2 = { class: "transaction-message__header" }
const _hoisted_3 = { class: "transaction-message__text" }
const _hoisted_4 = {
  key: 0,
  class: "transaction-message__additional-text"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionMessage',
  props: {
  additionalText: { type: String, required: false },
  text: { type: String, required: true },
  title: { type: String, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.text), 1),
    (__props.additionalText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.additionalText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})